type TimeframeValue = "daily" | "weekly" | "monthly";

interface DataTabsToolbarProps {
  timeframe: TimeframeValue;
  onTimeframeChange: (tf: TimeframeValue) => void;
  symbolQuery: string;
  onSymbolQueryChange: (q: string) => void;
  hideMonthly?: boolean;
}

const INPUT_STYLE = {
  background: "rgba(15, 23, 42, 0.6)",
  color: "var(--color-text)",
  border: "1px solid rgba(148, 163, 184, 0.25)",
  borderRadius: "0.5rem",
  padding: "0.5rem 0.75rem",
  fontSize: "0.9rem",
} as const;

export default function DataTabsToolbar({ timeframe, onTimeframeChange, symbolQuery, onSymbolQueryChange, hideMonthly = false }: DataTabsToolbarProps) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "1.25rem",
        flexWrap: "wrap",
        marginBottom: "1.5rem",
        padding: "1rem 1.1rem",
        background: "rgba(15, 23, 42, 0.54)",
        border: "1px solid rgba(148, 163, 184, 0.16)",
        borderRadius: "14px",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: "0.75rem" }}>
        <label htmlFor="timeframe-toggle" style={{ color: "rgba(241, 245, 249, 0.7)", fontSize: "0.9rem" }}>
          Timeframe
        </label>
        <select
          id="timeframe-toggle"
          value={timeframe}
          onChange={(e) => onTimeframeChange(e.target.value as TimeframeValue)}
          style={{ ...INPUT_STYLE, minWidth: "160px" }}
        >
          <option value="daily">Daily</option>
          <option value="weekly">Weekly</option>
          {!hideMonthly && <option value="monthly">Monthly</option>}
        </select>
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: "0.75rem" }}>
        <label htmlFor="symbol-search" style={{ color: "rgba(241, 245, 249, 0.7)", fontSize: "0.9rem" }}>
          Search symbol
        </label>
        <input
          id="symbol-search"
          type="text"
          value={symbolQuery}
          onChange={(e) => onSymbolQueryChange(e.target.value)}
          placeholder="e.g., HUBC"
          style={{ ...INPUT_STYLE, minWidth: "220px" }}
        />
      </div>
    </div>
  );
}
